// extracted by mini-css-extract-plugin
export default {"container":"styles_container__8dMff","shade":"styles_shade__wjMHU"};